import { useState } from 'react';
import { FaSun, FaCloudSun, FaCloud } from 'react-icons/fa';

interface ShadeSelectorProps {
  onShadeChange: (shadeValue: number) => void;
}

const ShadeSelector = ({ onShadeChange }: ShadeSelectorProps) => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (option: string) => {
    let shadeValue = 0; // Default value for 'No Shade'

    if (option === 'someShade') {
      shadeValue = -10;
    } else if (option === 'lotsOfShade') {
      shadeValue = -20;
    }

    setSelectedOption(option);
    onShadeChange(shadeValue); // Call the callback function from the parent with the shade value
  };

  return (
    <div className="flex">
      <button
        className={`w-36 h-24 rounded-l-lg border-slate-300 border-r-2 p-2 ${
          selectedOption === 'noShade' ? 'bg-primary text-white' : 'bg-gray-200'
        }`}
        onClick={() => handleOptionChange('noShade')}
      >
        <FaSun className="text-3xl mx-auto m-1" />
        No Shade
      </button>
      <button
        className={`w-36 h-24 border-slate-300 border-r-2 p-2 ${
          selectedOption === 'someShade'
            ? 'bg-primary text-white '
            : 'bg-gray-200'
        }`}
        onClick={() => handleOptionChange('someShade')}
      >
        <FaCloudSun className="text-3xl mx-auto m-1" />
        Some Shade
      </button>
      <button
        className={`w-36 h-24 rounded-r-lg p-2 ${
          selectedOption === 'lotsOfShade'
            ? 'bg-primary text-white'
            : 'bg-gray-200'
        }`}
        onClick={() => handleOptionChange('lotsOfShade')}
      >
        <FaCloud className="text-3xl mx-auto m-1" />
        Lots of Shade
      </button>
    </div>
  );
};

export default ShadeSelector;
